// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-overlay__2VU7p","modal":"modal-modal__3nVDR"};